import useToggle from '@alltrails/shared/hooks/useToggle';
import CustomProvider from 'components/CustomProvider';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import * as styles from './styles/styles.module.scss';
import DeleteModal from './DeleteModal/DeleteModal';

type Props = {
  trackId: number;
  userSlug: string;
};

function DeleteRecording({ trackId, userSlug }: Props) {
  const [isOpen, toggle] = useToggle(false);

  return (
    <CustomProvider>
      <div className={`btn ${styles.button}`} onClick={toggle} role="button">
        <FormattedMessage defaultMessage="Delete" />
      </div>
      <DeleteModal isOpen={isOpen} toggle={toggle} trackId={trackId} userSlug={userSlug} />
    </CustomProvider>
  );
}

export default DeleteRecording;
